import { TextField } from "@mui/material";
import { useState, useEffect } from "react";

const EditableTextField = ({ initialValue, onSave, disabled, autoFocus }) => {
  const [value, setValue] = useState(initialValue || "");

  useEffect(() => {
    setValue(initialValue || "");
  }, [initialValue]);

  const handleChange = (e) => {
    setValue(e.target.value);
  };

  const handleBlur = () => {
    if (value !== initialValue) {
      onSave(value);
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      e.target.blur();
    }
  };

  return (
    <TextField
      value={value}
      align={"left"}
      variant={"filled"}
      size={"small"}
      disabled={disabled}
      hiddenLabel
      onChange={handleChange}
      onBlur={handleBlur}
      onKeyDown={handleKeyDown}
      onClick={(e) => e.stopPropagation()}
      autoFocus={autoFocus}
    />
  );
};

export default EditableTextField;
